<template>
    <ErrorPage>
        <template slot="Title">
            Something is missing!
        </template>
        <template slot="SubTitle">
            To create your first template, you will need:
        </template>
        <template slot="Content">
            <div class="helper-container">
                <RequiredActionItem :state="hasBox?'success':'pending'">
                    <template>
                        <span>A <a href="#" @click="$router.push({name:'BoxList', params:{boxType:'MUSIC'}});">music box</a> including your music files</span>
                    </template>
                </RequiredActionItem>

                <RequiredActionItem :state="!hasBox?'disabled':(hasClock?'success':'pending')">
                    <template>
                        <span>A <a href="#" @click="$router.push({name:'ClocksHome'})">clock</a> containing your music boxes</span>
                    </template>
                </RequiredActionItem>
            </div>
        </template>
        <template slot="Actions">
            <Button v-if="!hasBox" :empty="true" @click="$router.push({name:'BoxesHome', params:{boxType:'MUSIC'}})">Back to music boxes</Button>
            <Button v-else-if="!hasClock" :empty="true" @click="$router.push({name:'ClocksHome'})">Back to clocks</Button>
        </template>
    </ErrorPage>
</template>

<script>
    import store from '@/store'
    import router from '@/router'
    import RequiredActionItem from'@/components/common/RequiredActionItem.vue'
    import Button from'@/components/common/Button.vue'
    import ErrorPage from'@/components/common/ErrorPage.vue'
    import { mapState, mapMutations, mapActions } from 'vuex';

    export default {
        name: "DayTemplateStuckedCard",
        store, router,
        components: {
            Button, RequiredActionItem, ErrorPage
        },
        computed: {
            ...mapState({
                hasClock: function () { return store.state.stationClocks != null && store.state.stationClocks.count > 0; },
                hasBox: function () { return store.state.stationBoxes != null && store.state.stationBoxes.count > 0; },
            })
        },
        methods: {}
    }
</script>

<style scoped>
</style>